import axios from 'axios';

function getUrl(path = '') {
  let bookingDomain = typeof process.env.BOOKING_URL !== 'undefined' ? process.env.BOOKING_URL : 'https://booking.builderall.com';
  let url = `${bookingDomain}/api/cheetah/`;
  const token = '?token=xDGUnmVKABEhuW6XZmuViOMKralmknT5wlpAxOrIFLuilEKcn0wv1f3GE5O1jODk';

  url = url + path + token;

  return url;
}

export const getCalendar = (user_id) => axios.get(getUrl(`user-calendars/${user_id}`));



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/booking.js